export const SUMMARYTABLE_ACTIONS = {
  ADD_SUMMARY: 'ADD_SUMMARY',
  RESET_SUMMARY: 'RESET_SUMMARY'
};
